import { render } from "./calculationModel.vue?vue&type=template&id=0d45321e"
import script from "./calculationModel.vue?vue&type=script&lang=js"
export * from "./calculationModel.vue?vue&type=script&lang=js"

import "./calculationModel.vue?vue&type=style&index=0&id=0d45321e&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__